import React from 'react';
import { FunnelIcon, CalendarDaysIcon } from '@heroicons/react/24/outline';

const DashboardFilters = ({
  dateRange = 30,
  onDateRangeChange,
  loading = false
}) => {
  const dateRangeOptions = [
    { value: 7, label: '7 Days' },
    { value: 30, label: '30 Days' },
    { value: 90, label: '90 Days' }
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-2">
          <FunnelIcon className="h-5 w-5 text-gray-500" />
          <span className="text-sm font-semibold text-gray-700">Filters</span>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
          {/* Date Range Filter */}
          <div className="flex flex-wrap items-center gap-2">
            <CalendarDaysIcon className="h-4 w-4 text-gray-500" />
            <span className="text-sm text-gray-600">Time Range:</span>
            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
              {dateRangeOptions.map((option) => (
                <button
                  key={option.value}
                  onClick={() => onDateRangeChange(option.value)}
                  disabled={loading}
                  className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors duration-200 ${
                    dateRange === option.value
                      ? 'bg-white text-blue-600 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  } disabled:opacity-50`}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Active Filters Summary */}
      {dateRange !== 30 && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs text-gray-500">Active filters:</span>

            {dateRange !== 30 && (
              <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-blue-100 text-blue-700">
                Last {dateRange} days
              </span>
            )}

            {dateRange !== 30 && (
              <button
                onClick={() => onDateRangeChange(30)}
                className="text-xs text-gray-500 hover:text-gray-700 underline"
              >
                Clear filter
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardFilters;
